import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'ui-bordered-control-wrapper',
  templateUrl: './control-bordered-wrapper.component.html',
  styleUrls: ['./control-bordered-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ControlBorderedWrapperComponent {
  @Input() invalid = false;
  @Input() disabled = false;
  @Input() size: 'regular' | 'large' = 'regular';
}
